import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { dictionaryItem } from '../../hocs/withDictionary';

import Title from '../ui/Title';
import Text from '../ui/Text';
import QuoteRemoveComponent from '../Quote/QuoteRemoveComponent';

import svgError from '../../static/images/icons/Error.svg';

import {
  Actions,
  Action,
  ActionBrand,
  AlertIcon,
} from './PopUp.styles';

const propTypes = {
  componentId: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
};

const RemovePackagePopUp = ({
  componentId,
  handleClose,
}) => (
  <>
    <AlertIcon icon={svgError} />

    <Title align="center" tag={3} size={2} marginBottom dictionary={dictionaryItem('RemovePackagePopUp')} />

    <Text align="center" dictionary={dictionaryItem('RemovePackagePopUp')} size="1rem" />
    <Actions>
      <Action
        onClick={handleClose}
        dictionary={dictionaryItem('RemovePackagePopUp', 'Decline')}
      />
      <QuoteRemoveComponent
        componentIds={componentId}
        onSuccess={handleClose}
      >
        <ActionBrand
          dictionary={dictionaryItem('RemovePackagePopUp', 'Confirm')}
        />
      </QuoteRemoveComponent>
    </Actions>
  </>
);

RemovePackagePopUp.propTypes = propTypes;

export default memo(RemovePackagePopUp);
